import { Link } from 'react-router-dom';

import { useAuth } from '../features/auth/auth-context';
import { paths } from '../routes/paths';

import styles from './CustomerPortalHeader.module.css';
import { BellIcon } from './DashboardIcons';

function displayInitials(firstName: string | null | undefined, email: string | null): string {
  if (firstName !== null && firstName !== undefined && firstName.trim() !== '') {
    return firstName.trim().slice(0, 1).toUpperCase();
  }

  if (email !== null && email.length > 0) {
    return email.slice(0, 1).toUpperCase();
  }

  return '?';
}

function displayName(firstName: string | null | undefined, email: string | null): string {
  if (firstName !== null && firstName !== undefined && firstName.trim() !== '') {
    return firstName.trim();
  }

  if (email !== null) {
    return email.split('@')[0] ?? 'Customer';
  }

  return 'Customer';
}

export function CustomerPortalHeader({
  greeting,
  subtitle,
  customerFirstName,
  actionCount = 0,
}: {
  greeting: string;
  subtitle: string;
  customerFirstName?: string | null;
  actionCount?: number;
}): React.JSX.Element {
  const { user } = useAuth();
  const email = user?.email ?? null;
  const resolvedName = displayName(customerFirstName, email);

  return (
    <header className={styles.header}>
      <div className={styles.greetingBlock}>
        <h1 className={styles.greeting}>{greeting}</h1>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>

      <div className={styles.utilities}>
        <p className={styles.tagline}>Clean Energy. Brighter Lives.</p>

        <Link
          className={styles.bellButton}
          to={paths.customerTimeline}
          aria-label={
            actionCount > 0
              ? `View activity timeline, ${actionCount} actions pending`
              : 'View activity timeline'
          }
        >
          <BellIcon />
          {actionCount > 0 && (
            <span className={styles.bellBadge} aria-hidden="true">
              {actionCount > 9 ? '9+' : actionCount}
            </span>
          )}
        </Link>

        <Link className={styles.profileChip} to={paths.customerProfile}>
          <span className={styles.avatar} aria-hidden="true">
            {displayInitials(customerFirstName, email)}
          </span>
          <span className={styles.profileText}>
            <span className={styles.profileName}>{resolvedName}</span>
            <span className={styles.profileRole}>Customer</span>
          </span>
        </Link>
      </div>
    </header>
  );
}
